import { useEffect, useState } from "react";
import AdminLogin from "@/admin/AdminLogin";
import AdminPanel from "@/admin/AdminPanel";
import { api } from "@/admin/editors";

export default function AdminApp() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-navy">
        <p className="font-mono text-sm tracking-widest text-slate-400">LOADING…</p>
      </div>
    );
  }

  if (!user) return <AdminLogin onSuccess={setUser} />;

  return (
    <AdminPanel
      user={user}
      onLogout={async () => {
        await api.post("/auth/logout").catch(() => {});
        setUser(null);
      }}
    />
  );
}
